var React = require('react');

function SmallNextArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.2929 32.2071L34.5 38L33.7929 37.2929L39.0858 32L22 32L22 31L39.0858 31L33.7929 25.7071L34.5 25L40.2929 30.7929L40.2929 30.7929L41 31.5L41 31.5L40.2929 32.2071Z","fill":"#ED9C78"}));
}

SmallNextArrowInline.defaultProps = {"viewBox":"0 0 63 63","fill":"none"};

module.exports = SmallNextArrowInline;

SmallNextArrowInline.default = SmallNextArrowInline;
